module.exports = {
	"locales": [
		"en"
	],
	"messages": {
		"App": {
			"title": "Yet another revenge app"
		},
		"Hello": {
			"hello": "hello"
		},
		"Login": {
			"login": "Login",
			"username": "username",
			"password": "password",
			"error": "error",
			"processing": "processing"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/app/locales/en.json
// module id = 370
// module chunks = 0